angular.module('am4').factory('messagesService', function(apiUrl, $http) {
    return {
        facility: function(facility_id) {
            return {
                all: function(options) {
                    var include_expired = options && options.include_expired;

                    return $http
                    .get(
                        apiUrl + '/facilities/' + facility_id + '/messages',
                        {
                            params: {
                                include_expired: include_expired ? 1 : 0
                            }
                        }
                    )
                    .then(function(res) {
                        return res.data;
                    });
                },
                create: function(message) {
                    return $http
                    .post(
                        apiUrl + '/facilities/' + facility_id + '/messages',
                        {
                            message: message
                        }
                    )
                    .then(function(res) {
                        return res.data;
                    });
                },
                get: function(message_id) {
                    return $http
                    .get(
                        apiUrl +
                            '/facilities/' +
                            facility_id +
                            '/messages/' +
                            message_id
                    )
                    .then(function(res) {
                        return res.data;
                    });
                },
                update: function(message_id, message) {
                    return $http
                    .put(
                        apiUrl +
                            '/facilities/' +
                            facility_id +
                            '/messages/' +
                            message_id,
                        {
                            message: message
                        }
                    )
                    .then(function(res) {
                        return res.data;
                    });
                },
                remove: function(message_id) {
                    return $http
                    .delete(
                        apiUrl +
                            '/facilities/' +
                            facility_id +
                            '/messages/' +
                            message_id
                    )
                    .then(function(res) {
                        return res.data;
                    });
                },
                group: function(group_id) {
                    return {
                        all: function(options) {
                            var include_expired =
                                options && options.include_expired;

                            return $http
                            .get(
                                apiUrl +
                                    '/facilities/' +
                                    facility_id +
                                    '/group/' +
                                    group_id +
                                    '/messages',
                                {
                                    params: {
                                        include_expired: include_expired
                                            ? 1
                                            : 0
                                    }
                                }
                            )
                            .then(function(res) {
                                return res.data;
                            });
                        },
                        create: function(message) {
                            return $http
                            .post(
                                apiUrl +
                                    '/facilities/' +
                                    facility_id +
                                    '/group/' +
                                    group_id +
                                    '/messages',
                                {
                                    message: message
                                }
                            )
                            .then(function(res) {
                                return res.data;
                            });
                        },
                        get: function(message_id) {
                            return $http
                            .get(
                                apiUrl +
                                    '/facilities/' +
                                    facility_id +
                                    '/group/' +
                                    group_id +
                                    '/messages/' +
                                    message_id
                            )
                            .then(function(res) {
                                return res.data;
                            });
                        },
                        update: function(message_id, message) {
                            return $http
                            .put(
                                apiUrl +
                                    '/facilities/' +
                                    facility_id +
                                    '/group/' +
                                    group_id +
                                    '/messages/' +
                                    message_id,
                                {
                                    message: message
                                }
                            )
                            .then(function(res) {
                                return res.data;
                            });
                        },
                        remove: function(message_id, group_id) {
                            return $http
                            .delete(
                                apiUrl +
                                    '/facilities/' +
                                    facility_id +
                                    '/group/' +
                                    group_id +
                                    '/messages/' +
                                    message_id
                            )
                            .then(function(res) {
                                return res.data;
                            });
                        }
                    };
                }
            };
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/messages.js